import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { productApi, orderApi, userApi, inquiryApi } from '../services/api';
import { Package, ShoppingBag, Users, MessageSquare } from 'lucide-react';

function StatCard({ icon: Icon, label, value, color, to }) {
  return (
    <Link to={to} className={`stat-card stat-${color}`}>
      <div className="stat-icon"><Icon size={28} /></div>
      <div className="stat-info">
        <span className="stat-value">{value ?? '…'}</span>
        <span className="stat-label">{label}</span>
      </div>
    </Link>
  );
}

export default function Dashboard() {
  const [stats,  setStats]  = useState({});
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    Promise.all([
      productApi.getAll(),
      orderApi.getAll(),
      userApi.getAll(),
      inquiryApi.getAll(),
    ]).then(([prod, ord, usr, inq]) => {
      setStats({
        products:  prod.data.length,
        orders:    ord.data.length,
        users:     usr.data.length,
        inquiries: inq.data.filter((i) => i.status === 'unread').length,
      });
      setOrders(ord.data.slice(0, 5));
    }).catch(console.error);
  }, []);

  return (
    <div className="admin-page">
      <h1 className="admin-page-title">Dashboard</h1>

      {/* Stats */}
      <div className="stats-grid">
        <StatCard icon={Package}      label="Products"          value={stats.products}  color="blue"   to="/products"  />
        <StatCard icon={ShoppingBag}  label="Orders"            value={stats.orders}    color="green"  to="/orders"    />
        <StatCard icon={Users}        label="Users"             value={stats.users}     color="purple" to="/users"     />
        <StatCard icon={MessageSquare}label="Unread Inquiries"  value={stats.inquiries} color="orange" to="/inquiries" />
      </div>

      {/* Recent Orders */}
      <div className="admin-section">
        <div className="admin-section-header">
          <h2>Recent Orders</h2>
          <Link to="/orders" className="btn btn-ghost btn-sm">View All</Link>
        </div>
        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Order #</th><th>Customer</th><th>Items</th><th>Total</th><th>Status</th><th>Date</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id}>
                  <td><Link to={`/orders/${o.id}`}>{o.orderNumber}</Link></td>
                  <td>{o.userEmail}</td>
                  <td>{o.items.length}</td>
                  <td>₹{o.total.toFixed(2)}</td>
                  <td><span className={`status-badge status-${o.status}`}>{o.status}</span></td>
                  <td>{new Date(o.createdAt).toLocaleDateString('en-IN')}</td>
                </tr>
              ))}
              {orders.length === 0 && (
                <tr><td colSpan={6} className="empty-row">No orders yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
